import Activate from '../../atoms/buttons/modalActivate';
import ListContext from '../../../../shared/components/utils/context/listContext';
import Props from '../../../../shared/types/props/button';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useCallback, useContext, useEffect, useState } from 'react';

function ActivateButton({ action, index }: Props) {
  const { listIndex } = useContext(ListContext);
  const [focused, setFocused] = useState(false);

  // Event handlers

  const onPointerEnter = useCallback(() => {
    setFocused(true);
  }, []);

  const onPointerLeave = useCallback(() => {
    setFocused(listIndex === index);
  }, [listIndex]);

  // Effect hooks

  useEffect(() => {
    setFocused(listIndex === index);
  }, [listIndex]);

  return (
    <Activate
      focused={focused}
      onClick={action}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
    >
      {TranslationManager.get('MODAL.ANONYMOUS.BUTTONS.ACTIVATE')}
    </Activate>
  );
}

export default ActivateButton;
